module.exports = __webpack_public_path__ + "img/product.c265e493.svg";